import React, { lazy } from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const Dashboard = lazy(() =>
  import("@/pages/travelDashboard/TravelDashboard")
);

const TravelDashboard = [

  {
    path: "travelDashboard",
    element: (
      <SuspenseWrapper>
        <Dashboard />
      </SuspenseWrapper>
    ),
  },
 
];

export default TravelDashboard;
